import { apiCall } from "api-calls/api-call"
import { SupportedGame, SupportedGameUpdate } from "../store/types"

export const getSupportedGames = async(): Promise<SupportedGame[]> => {
  return apiCall({ method: "GET", path: "gameplay-boost/supported-games" })
}

export const patchSupportedGame = async(gameId: number, body: SupportedGameUpdate): Promise<SupportedGame> => {
  return apiCall({ method: "PATCH", path: `gameplay-boost/supported-games/${gameId}`, body })
}
